module.exports = __webpack_public_path__ + "img/image.f22fb6e9.png";